var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechaabajo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 71,
    viewBox: "0 0 46 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1213 69.8518C23.9497 71.0234 22.0503 71.0234 20.8787 69.8518L1.7868 50.7599C0.615223 49.5883 0.615223 47.6888 1.7868 46.5173C2.95837 45.3457 4.85786 45.3457 6.02944 46.5173L23 63.4878L39.9706 46.5173C41.1421 45.3457 43.0416 45.3457 44.2132 46.5173C45.3848 47.6888 45.3848 49.5883 44.2132 50.7599L25.1213 69.8518ZM26 -0.000305176V67.7305H20V-0.000305176H26Z",
    fill: "#FFC427"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaabajo);
export default __webpack_public_path__ + "static/media/flechaabajo.43a82612469175d9ef04573c41e03ff8.svg";
export { ForwardRef as ReactComponent };